






























import Vue from "vue";
import { mapGetters } from "vuex";
import SupplierLeads from "../components/Home/SupplierLeads.vue";
import SupplierAffiliates from "../components/Home/SupplierAffiliates.vue";

export default Vue.extend({
  name: "Home",

  data: () => ({
    // suppliers: [],
  }),

  components: {
    SupplierLeads,
    SupplierAffiliates,
  },

  computed: {
    ...mapGetters({
      user: "user",
      suppliers: "suppliers",
    }),
  },
});
